import { TMargin } from '@libs/types';
import React, { useMemo } from 'react';
import loading from '../../animations/loading.json';
import { sanitizeLottieName } from '../../utils/sanitize';
import { getInlineStyles } from '../../utils/styles';
import { recolorLottie } from './recolorLottie';
import { useLottieAnimation } from './useLottieAnimation';

export type TLottieAnimationViewProps = {
    uid?: string;
    animationsColor?: string;
    margin?: TMargin;
};

export const LoadingAnimationView = ({ uid, animationsColor, margin }: TLottieAnimationViewProps) => {
    const finalUid = uid ?? 'loader';
    const sanitizedUid = sanitizeLottieName(finalUid);
    const animationData = useMemo(() => (animationsColor ? recolorLottie(loading, animationsColor) : loading), [animationsColor]);

    const { element } = useLottieAnimation({
        uid: sanitizedUid,
        animationData,
        loop: true,
        autoplay: true,
    });
    return <div data-test={finalUid} ref={element} style={getInlineStyles({ margin, height: '80px', width: '80px' })} />;
};
